var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinDepIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2l5.391 5H18.5v11H4a3 3 0 01-3-3V6.5A2.5 2.5 0 013.5 4h5.344L11 2zm0 3l2.316 2H8.684L11 5zM6.687 6L5.609 7H3.5a.5.5 0 110-1h3.187zM3 8.95V15a1 1 0 001 1h12.5V9h-13c-.171 0-.338-.017-.5-.05zm10 1.55l-2 2 2 2 2-2-2-2z",
    fill: "#9A9CAC"
  })));
}

export default SvgMinDepIcon;